/* eslint-disable space-before-function-paren */
import React, { useState } from 'react'
import './header.scss'
import { graphql, useStaticQuery } from 'gatsby'

// import cima from '../../images/icon/home/seta-para-baixo.svg'
// import baixo from '../../images/icon/seta-para-baixo.svg'

// assets
// import lupa from '../../images/lupa.svg'
import logo from '../../images/icon/logo2.svg'
import menu from '../../images/icon/home/icone menu.svg'
import fechar from '../../images/icon/home/fechar.svg'
import Brasil from '../../images/icon/header/brasil.png'
import Ingles from '../../images/icon/header/ingles.png'
import Espanhol from '../../images/icon/header/espanhol.png'
import { useIntl, changeLocale, Link } from 'gatsby-plugin-react-intl'

// components
import ModalSearch from '../SearchModal/search'

export default function headerMobile({ location }) {
  const data = useStaticQuery(
    graphql`
      query {
        allEditorias: allContentfulEditorias(
          filter: {node_locale: {eq: "pt-BR"}}
        ) {
          nodes {
            node_locale
            nome
            slug
          }
        }
      }
    `)

  const categories = [{ name: 'Todos', slug: '/blog' }, ...data.allEditorias.nodes.map((ed) => { return { name: ed.nome, slug: ed.slug } })]

  const [active, setActive] = useState(false)
  const [openMenu, setOpenMenu] = useState(false)
  const [opened] = useState(true)
  // eslint-disable-next-line no-unused-vars

  const handleMobileMenu = () => {
    setOpenMenu(!openMenu)
    if (!openMenu) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
      document.getElementsByTagName('html')[0].style.overflow = 'hidden'
    } else {
      document.getElementsByTagName('html')[0].style.overflow = 'auto'
      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    }
  }

  React.useEffect(() => {
    return () => {
      document.getElementsByTagName('body')[0].style.overflow = 'auto'
    }
  }, [])

  const intl = useIntl()

  return (
    <>
      <header id="headerMobile" className="position-relative">
        <nav className="height2 bg-dia-red d-flex align-items-center justify-content-between px-4">
          <div className="logoMobile" ><Link aria-label="logohome" to="/"><img src={logo} alt="logo" /></Link></div>
          <div className="pl-0">
            {/* <button aria-label="LupaButton" onClick={() => setActive(true)} className="lupaButton"><img src={lupa} alt="lupa"/> </button> */}
            <div>
              <span className="cursor-pointer font-size-09 mr-1" onClick={() => changeLocale('pt')}>
                <img src={Brasil} alt="Português" width="24" height="16" />
              </span>
              <span className="cursor-pointer font-size-09 mr-1" onClick={() => changeLocale('en')}>
                <img src={Ingles} alt="English" width="24" height="16" />
              </span>
              <span className="cursor-pointer font-size-09" onClick={() => changeLocale('es')}>
                <img src={Espanhol} alt="Español" width="24" height="16" />
              </span>
            </div>
          </div>
          <div onClick={() => handleMobileMenu()}>
            <img src={openMenu ? fechar : menu} alt="Button" />
          </div>
        </nav>

        {
          openMenu && (
            <div className="heightMenu">
              <div className="">
                <div className="">
                  <div className="menuWhite">
                    <Link to="/nossa-essencia/" onClick={() => handleMobileMenu()}>
                      <div className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem pt-3">
                        {intl.formatMessage({ id: 'components.navbar.link1' })}
                      </div>
                    </Link>
                    <div>
                      <div
                        className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem"
                      >
                        {intl.formatMessage({ id: 'components.navbar.link2' })}
                      </div>
                      <div className={opened ? 'dropdown-nav-mobile' : 'd-none'}>
                        <div className="navbarBoxMobile my-1">
                          <Link to="/coleta-de-oleo-lubrificante-usado/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='text-white font-size-09 nav-item bg-lwart-lightblue2' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link1' })}
                            </div>
                          </Link>
                          <Link to="/oleos-de-alta-performance/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='nav-item bg-lwart-darkblue mt-1 text-white font-size-09' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link2' })}
                            </div>
                          </Link>
                          <Link to="/g2/" onClick={() => handleMobileMenu()} >
                            <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link3' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/lwoma/" onClick={() => handleMobileMenu()} >
                            <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link4' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/lw-volt/" className="pb-2" onClick={() => handleMobileMenu()} >
                            <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link5' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/grau-alimenticio/" className="pb-2" onClick={() => handleMobileMenu()} >
                            <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link13' })}
                            </div>
                          </Link>
                          {/* <Link to="/gestao-de-residuos/" onClick={() => handleMobileMenu()} >
                            <div id="prod-lwart-link" className='text-white font-size-09 nav-item bg-lwart-green'>
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link6' })}
                            </div>
                          </Link> */}
                          {/* <Link to="/gestao-total-de-residuos/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='nav-item text-dark font-size-09 '>
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link7' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/coleta-e-destinacao-de-residuos/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='nav-item text-dark font-size-09 ' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link8' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/assessoria-ambiental/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='nav-item text-dark font-size-09 ' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link9' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/transbordo-de-residuos/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='nav-item text-dark font-size-09 ' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link10' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <Link to="/scrap-produtivo-e-descaracterizacao/" onClick={() => handleMobileMenu()}>
                            <div id="prod-lwart-link" className='nav-item text-dark font-size-09 ' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link11' })}
                            </div>
                          </Link>
                          <div className='bg-lwart-blue hr'></div>
                          <a href='https://sga.lwart.com.br/' target="_blank" onClick={() => handleMobileMenu()} className="pb-2" rel="noreferrer">
                            <div id="prod-lwart-link" className='nav-item text-dark font-size-09 pb-lg-2 pb-2' >
                              {intl.formatMessage({ id: 'components.navbar.sublinks.link12' })}
                            </div>
                          </a> */}
                        </div>
                      </div>
                    </div>
                    <Link to="/sustentabilidade/" onClick={() => handleMobileMenu()}>
                      <div className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem">
                        {intl.formatMessage({ id: 'components.navbar.link3' })}
                      </div>
                    </Link>
                    {intl.locale === 'pt' &&
                      <div>
                        <Link className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem" to="/blog/" onClick={() => handleMobileMenu()}>
                          Blog
                        </Link>
                        <div className={opened ? 'dropdown-nav-mobile' : 'd-none'}>
                          <div className="navbarBoxMobile">
                            {categories.map((category, index) => (
                              <Link
                                key={category.slug}
                                to={category.name === 'Todos' ? category.slug : `/blog/editoria/${category.slug}`}
                                onClick={() => handleMobileMenu()}
                              >
                                <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                                  {category.name}
                                </div>
                                {index !== categories.length - 1 && (
                                  <div className="bg-lwart-blue hr"></div>
                                )}
                              </Link>
                            ))}
                          </div>
                        </div>
                      </div>
                    }
                    <Link to="/gente/" onClick={() => handleMobileMenu()}>
                      <div className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem" >
                        {intl.formatMessage({ id: 'components.navbar.link5' })}
                      </div>
                    </Link>
                    {
                      intl.locale === 'pt'
                        ? <div>
                          <Link className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem" to="/informacoes-bonds/" onClick={() => handleMobileMenu()}>
                            RI
                          </Link>
                          <div className={opened ? 'dropdown-nav-mobile' : 'd-none'}>
                            <div className="navbarBoxMobile my-1">
                              <Link to="/informacoes-bonds/" onClick={() => handleMobileMenu()} >
                                <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                                  Informações Bonds
                                </div>
                              </Link>
                              <div className='bg-lwart-blue hr'></div>
                              <Link to="/informacoes-financeiras/" className="pb-2" onClick={() => handleMobileMenu()} >
                                <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                                  Informações Financeiras
                                </div>
                              </Link>
                              <div className='bg-lwart-blue hr'></div>
                              <Link to="/fale-com-ri/" className="pb-2" onClick={() => handleMobileMenu()} >
                                <div id="prod-lwart-link" className='text-dark font-size-09 nav-item'>
                                  Fale com RI
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                        : ''
                    }
                    {
                      intl.locale === 'pt'
                        ? <Link to="/fornecedores/" onClick={() => handleMobileMenu()}>
                          <div className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem" >
                            Fornecedores
                          </div>
                        </Link>
                        : ''
                    }
                    {
                      intl.locale === 'pt'
                        ? <Link to="/projeto-h/" onClick={() => handleMobileMenu()}>
                          <div className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem" >
                            H+
                          </div>
                        </Link>
                        : ''
                    }
                    <Link to="/fale-com-a-gente/" onClick={() => handleMobileMenu()}>
                      <div className="text-center d-block font-size-1 text-lwart-darkblue font-Spinnaker navItem" >
                        {intl.formatMessage({ id: 'components.navbar.link6' })}
                      </div>
                    </Link>
                    <div className='customSpace'>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        }
      </header>
      <ModalSearch active={active} setActive={setActive} location={location} />
    </>
  )
}
